import React, { useEffect, useState } from "react";
import { GetAllReports } from "Services/OtherApis";
import Table from "./table";
import { useTranslation } from "react-i18next";

function AllApplicants() {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dropdown, setDropDown] = useState("");
  useEffect(() => {
    getAllReportData();
  }, []);

  async function getAllReportData(value) {
    setLoading(true);
    try {
      const res = await GetAllReports(value);

      setData(res?.data || []); // Ensure data is always an array
    } catch (e) {
      console.error(t("Error fetching Reports"), e);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="w-full">
      <Table
        loading={loading}
        data={data}
        setDropDown={(e) => setDropDown(e)}
        dropdown={dropdown}
        dataTitles={dataTitles}
        isDropDown={true}
        getAllReportData={() => getAllReportData()}
      />
    </div>
  );
}

export default AllApplicants;
const dataTitles = [
  {
    id: "FinancialStatement",
    name: "Financial Statements",
  },
  {
    id: "BoardsOfDirecterReport",
    name: "Board of Director Report",
  },
];
